import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";


import api from "../services/api";
import {
  Card,
  CardBody,
  CardHeader,
  Table,
  Spinner,
  Alert,
  Input,
  Button,
} from "reactstrap";

const EmpDeductions = () => {
  const navigate = useNavigate();

  const [employee, setEmployee] = useState(null);
  const [plans, setPlans] = useState([]);
  const [selectedTiers, setSelectedTiers] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchEmployeeAndPlans = async () => {
      try {
        const empRes = await api.post("/employee/profile");
        const emp = empRes.data;
        setEmployee(emp);

        const plansRes = await api.get(`/benefit-plans/${emp.business_id}`);
        setPlans(plansRes.data || []);
      } catch (err) {
        console.error(err);
        setError("Failed to load employee or plan data.");
      } finally {
        setLoading(false);
      }
    };

    fetchEmployeeAndPlans();
  }, []);

  const groupedPlans = plans.reduce((acc, plan) => {
    if (!acc[plan.type]) acc[plan.type] = [];
    acc[plan.type].push(plan);
    return acc;
  }, {});

  const calculateEmployeeCost = (total, employerRate) => {
    if (!total || !employerRate) return "0.00";
    const cost = parseFloat(total) * (1 - employerRate / 100);
    return cost.toFixed(2);
  };

  const handleTierCheckbox = (planId, tier) => {
    setSelectedTiers((prev) => {
      const current = prev[planId] || {};
      return {
        ...prev,
        [planId]: {
          ...current,
          [tier]: !current[tier],
        },
      };
    });
  };

  const handleSubmit = async () => {
    try {
      const types = Object.keys(groupedPlans);
  
      for (const type of types) {
        const typePlanIds = groupedPlans[type].map((plan) => plan.id);
  
        const filteredSelections = Object.keys(selectedTiers)
          .filter((planId) => typePlanIds.includes(parseInt(planId)))
          .reduce((acc, planId) => {
            acc[planId] = selectedTiers[planId];
            return acc;
          }, {});
  
        if (Object.keys(filteredSelections).length > 0) {
          await api.post("/employee-benefits", {
            type,
            selections: filteredSelections,
          });
        }
      }
  
      alert("Benefit selections saved successfully.");
    } catch (err) {
      console.error("Error submitting benefit selections:", err);
      alert("Failed to save selections.");
    }
  };
  

  if (loading)
    return (
      <p className="text-center mt-5">
        <Spinner /> Loading deductions...
      </p>
    );

  return (
    <Card className="shadow-lg mt-4">
    <div className="text-start mb-3">
  <Button color="secondary" onClick={() => navigate("/emp-dashboard/emp-benefits-summary")}>
    ← Back to My Benefits
  </Button>
</div>

      <CardHeader style={{textAlign:'center'}} tag="h4">Available Benefit Plans</CardHeader>
      

      <CardBody>
        {error && <Alert color="danger">{error}</Alert>}

        {employee && (
          <p className="text-muted">
            Welcome, {employee.first_name} {employee.last_name} (ID: {employee.id})
          </p>
        )}

        {Object.keys(groupedPlans).map((type) => (
          <div key={type} className="mb-5">
            <h5 className="text-capitalize mb-3">{type} Plans</h5>

            {groupedPlans[type].map((plan) => {
              const selected = selectedTiers[plan.id] || {};
              return (
                <div key={plan.id} className="mb-4 border p-3 rounded shadow-sm">
                  <div className="d-flex align-items-center justify-content-between mb-2">
                    <div>
                      <h6 className="mb-1">{plan.plan_name}</h6>
                      <p className="mb-0">
                        {plan.carrier_name}
                        {plan.logo_url && (
                          <img
                            src={plan.logo_url}
                            alt="logo"
                            height={24}
                            className="ms-2"
                          />
                        )}
                      </p>
                    </div>
                  </div>

                  <Table bordered responsive size="sm">
                    <thead>
                      <tr>
                        <th>Select</th>
                        <th>Coverage Tier</th>
                        <th>Total Cost</th>
                        <th>Your Cost</th>
                      </tr>
                    </thead>
                    <tbody>
                      {[
                        { label: "Employee Only", key: "employee_only", cost: plan.cost_employee_only },
                        { label: "Employee + Spouse", key: "employee_spouse", cost: plan.cost_employee_spouse },
                        { label: "Employee + Children", key: "employee_children", cost: plan.cost_employee_children },
                        { label: "Family", key: "family", cost: plan.cost_family },
                      ].map(({ label, key, cost }) => (
                        <tr key={key}>
                          <td>
                            <Input
                              type="checkbox"
                              checked={!!selected[key]}
                              onChange={() => handleTierCheckbox(plan.id, key)}
                            />
                          </td>
                          <td>{label}</td>
                          <td>${cost}</td>
                          <td>${calculateEmployeeCost(cost, plan.employer_contribution)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              );
            })}
          </div>
        ))}

        <div className="text-end">
          <Button color="primary" onClick={handleSubmit}>
            Submit Selections
          </Button>
        </div>
      </CardBody>
    </Card>
  );
};

export default EmpDeductions;





// import React, { useEffect, useState } from "react";
// import api from "../services/api";
// import {
//   Card,
//   CardBody,
//   CardHeader,
//   Table,
//   Spinner,
//   Alert,
//   Input,
//   Button,
// } from "reactstrap";

// const EmpDeductions = () => {
//   const [employee, setEmployee] = useState(null);
//   const [plans, setPlans] = useState([]);
//   const [selectedPlans, setSelectedPlans] = useState({});
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   useEffect(() => {
//     const fetchEmployeeAndPlans = async () => {
//       try {
//         const empRes = await api.post("/employee/profile");
//         const emp = empRes.data;
//         setEmployee(emp);

//         const plansRes = await api.get(`/benefit-plans/${emp.business_id}`);
//         setPlans(plansRes.data || []);
//       } catch (err) {
//         console.error(err);
//         setError("Failed to load employee or plan data.");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchEmployeeAndPlans();
//   }, []);

//   const handlePlanSelect = (type, planId) => {
//     setSelectedPlans((prev) => ({ ...prev, [type]: planId }));
//   };

//   const groupedPlans = plans.reduce((acc, plan) => {
//     if (!acc[plan.type]) acc[plan.type] = [];
//     acc[plan.type].push(plan);
//     return acc;
//   }, {});

//   const handleSubmit = () => {
//     console.log("Selected Plans:", selectedPlans);
//     alert("Selected plans submitted (this is a placeholder).");
//   };

//   if (loading)
//     return (
//       <p className="text-center mt-5">
//         <Spinner /> Loading deductions...
//       </p>
//     );

//   return (
//     <Card className="shadow-lg mt-4">
//       <CardHeader tag="h4">Available Benefit Plans</CardHeader>
//       <CardBody>
//         {error && <Alert color="danger">{error}</Alert>}

//         {employee && (
//           <p className="text-muted">
//             Welcome, {employee.first_name} {employee.last_name} (ID: {employee.id})
//           </p>
//         )}

//         {Object.keys(groupedPlans).map((type) => (
//           <div key={type} className="mb-4">
//             <h5 className="text-capitalize">{type} Plans</h5>
//             <Table bordered responsive>
//               <thead>
//                 <tr>
//                   <th>Select</th>
//                   <th>Plan Name</th>
//                   <th>Carrier</th>
//                   <th>Employee only (Individual)</th>
//                   <th>Employee and Spouse</th>
//                   <th>Employee and Children</th>
//                   <th>Family</th>
//                   <th>Employer Contribution</th>
//                 </tr>
//               </thead>
//               <tbody>
//   {groupedPlans[type].map((plan) => {
//     const empPct = 100 - parseFloat(plan.employer_contribution || 0);
//     const cost = (value) =>
//       value ? `$${((parseFloat(value) || 0) * empPct / 100).toFixed(2)}` : "$0.00";

//     return (
//       <React.Fragment key={plan.id}>
//         <tr>
//           <td>
//             <Input
//               type="radio"
//               name={`plan-${type}`}
//               checked={selectedPlans[type] === plan.id}
//               onChange={() => handlePlanSelect(type, plan.id)}
//             />
//           </td>
//           <td>{plan.plan_name}</td>
//           <td>
//             {plan.carrier_name}
//             {plan.logo_url && (
//               <img
//                 src={plan.logo_url}
//                 alt="logo"
//                 height={24}
//                 className="ms-2"
//               />
//             )}
//           </td>
//           <td>${plan.cost_employee_only}</td>
//           <td>${plan.cost_employee_spouse}</td>
//           <td>${plan.cost_employee_children}</td>
//           <td>${plan.cost_family}</td>
//           <td>{plan.employer_contribution}%</td>
//         </tr>
//         <tr style={{ backgroundColor: "#f8f9fa" }}>
//           <td colSpan="3">Your Cost:</td>
          
//           <td>{cost(plan.cost_employee_only)}</td>
//           <td>{cost(plan.cost_employee_spouse)}</td>
//           <td>{cost(plan.cost_employee_children)}</td>
//           <td>{cost(plan.cost_family)}</td>
//           <td></td>
//         </tr>
//       </React.Fragment>
//     );
//   })}
// </tbody>

//             </Table>
//           </div>
//         ))}

//         <Button color="primary" onClick={handleSubmit}>
//           Submit Selections
//         </Button>
//       </CardBody>
//     </Card>
//   );
// };

// export default EmpDeductions;
